import React from 'react';

const CustomLink = ({
  children,
  onClick = null,
  onKeyDown,
  className = '',
}) => (
  <span
    role="link"
    tabIndex={0}
    className={`span-link ${className}`.trim()}
    onClick={onClick}
    onKeyDown={(e) => {
      if (onKeyDown) onKeyDown(e);
      if ((e.key === 'Enter' || e.key === ' ') && onClick) {
        e.preventDefault();
        onClick(e);
      }
    }}
  >
    {children}
  </span>
);

export default CustomLink;
